module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kbOOA"))).then(() => parcelRequire('d0iPb'));